import { createAction } from "redux-actions";

import { createAsyncAction } from "../helpers";

export const getPresetDetailAsyncAction = createAsyncAction(
	"GET_PRESET_DETAIL_REQUEST",
	"GET_PRESET_DETAIL_SUCCESS",
	"GET_PRESET_DETAIL_FAILURE",
	"GET_PRESET_DETAIL_CANCEL"
);

export const getPresetItemsListAsyncAction = createAsyncAction(
	"GET_PRESET_ITEMS_LIST_REQUEST",
	"GET_PRESET_ITEMS_LIST_SUCCESS",
	"GET_PRESET_ITEMS_LIST_FAILURE",
	"GET_PRESET_ITEMS_LIST_CANCEL"
);

export const getPresetItemDetailAsyncAction = createAsyncAction(
	"GET_PRESET_ITEM_DETAIL_REQUEST",
	"GET_PRESET_ITEM_DETAIL_SUCCESS",
	"GET_PRESET_ITEM_DETAIL_FAILURE",
	"GET_PRESET_ITEM_DETAIL_CANCEL"
);

export const postPresetItemAsyncAction = createAsyncAction(
	"POST_PRESET_ITEM_REQUEST",
	"POST_PRESET_ITEM_SUCCESS",
	"POST_PRESET_ITEM_FAILURE",
	"POST_PRESET_ITEM_CANCEL"
);

export const updatePresetItemAsyncAction = createAsyncAction(
	"PUT_PRESET_ITEM_REQUEST",
	"PUT_PRESET_ITEM_SUCCESS",
	"PUT_PRESET_ITEM_FAILURE",
	"PUT_PRESET_ITEM_CANCEL"
);

export const resetAction = createAction("PRESET_ITEMS_RESET_ACTIONS");
